webpackJsonp([3],{

/***/ 1016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Common_AppVersion__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Login_LoginBackground__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login_LoginLogo__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Login_LoginSubscriberNumberForm__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Login_LoginRpcErrorMessage__ = __webpack_require__(1248);

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 11:18:28
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-23, 14:45:21
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




// COMPONENTS //////////////////////////////////////////////////////////////////





// dynamic import
var LoginSmsTokenForm = function LoginSmsTokenForm() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1252));
};
var LoginSubscriberPasswordForm = function LoginSubscriberPasswordForm() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1256));
};
var LoginCreatePasswordForm = function LoginCreatePasswordForm() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1260));
};

// CONTAINER ///////////////////////////////////////////////////////////////////
var Login = {
  components: {
    AppVersion: __WEBPACK_IMPORTED_MODULE_4__components_Common_AppVersion__["a" /* default */],
    LoginBackground: __WEBPACK_IMPORTED_MODULE_5__components_Login_LoginBackground__["a" /* default */],
    LoginLogo: __WEBPACK_IMPORTED_MODULE_6__components_Login_LoginLogo__["a" /* default */],
    LoginSubscriberNumberForm: __WEBPACK_IMPORTED_MODULE_7__components_Login_LoginSubscriberNumberForm__["a" /* default */],
    LoginRpcErrorMessage: __WEBPACK_IMPORTED_MODULE_8__components_Login_LoginRpcErrorMessage__["a" /* default */],
    LoginSmsTokenForm: LoginSmsTokenForm,
    LoginSubscriberPasswordForm: LoginSubscriberPasswordForm,
    LoginCreatePasswordForm: LoginCreatePasswordForm
  },
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['authType', 'subscriber', 'isAuthenticated', 'loginCredentialsIncorrect', 'loginLoadingActive', 'brandLogos', 'isError']), {
    mapAuthTypeToComponent: function mapAuthTypeToComponent() {
      var componentsMap = {
        initial: 'LoginSubscriberNumberForm',
        login: 'LoginSubscriberPasswordForm',
        createNewPassword: 'LoginCreatePasswordForm',
        createNewPasswordForRegisteredUser: 'LoginCreatePasswordForm',
        registration: 'LoginSmsTokenForm',
        sendSmsAfterPasswordChangeRequest: 'LoginSmsTokenForm'
      };

      return componentsMap[this.authType];
    }
  }),
  watch: {
    isAuthenticated: function isAuthenticated(value) {
      if (value) {
        window.location.reload(true);
        // this.$router.push('my-account');
      } else {
        this.$router.push('/');
      }
    }
  },
  template: '\n    <div class="my-container">\n      <LoginBackground />\n      <LoginLogo :brand-logos="brandLogos" />\n      <LoginRpcErrorMessage v-if="isError" />\n      <component v-if="!isError"\n        :is="mapAuthTypeToComponent" \n        :login-credentials-incorrect="loginCredentialsIncorrect" \n        :subscriber="subscriber" \n        :login-loading-active="loginLoadingActive"     \n      />\n      <AppVersion />\n    </div>\n  '
};

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('Login', Login));

/***/ }),

/***/ 1033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
* description:
* File of sNumberValidation Serivce
*
* Serwis jest odpowiedzialny za reużywalne funkcje pomocnicze.
*
* data : 2017-08-19
*/

var sNumberValidation = function () {
  return {
    __checkNumberLength: __checkNumberLength,
    __checkNumberCharacters: __checkNumberCharacters,
    validateNumber: validateNumber
  };
  // /// PRIVATE /////////////////////////////////////////////////////////////////
  /**
  * Metoda sprawdza długość numeru (domyślnie 9 znaków).
  *
  * @method __checkNumberLength(number, length)
  * @param {Integer} number - numer wpisany przez użytkownika
  * @param {Integer} length - maksymalna ilość znaków oczekiwanych w numerze
  * @return {Integer} zwraca 9 pierwszych cyfr z wpisanego numeru, resztę obcina
  * @access private
  */
  function __checkNumberLength(number) {
    var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;

    return number.length > maxLength ? number.substring(0, maxLength) : number;
  }
  /**
  * Metoda sprawdza czy numer składa sie jedynie z cyfr, jeśli nie to usuwa te znaki.
  *
  * @method __checkNumberCharacters(number)
  * @param {Integer} number - numer wpisany przez użytkownika
  * @return {String} zwraca pusty znak jeśli wpisany znak nie jest cyfrą
  * @access private
  */
  function __checkNumberCharacters(number) {
    var _number = number === null ? '' : number;
    return _number.toString().replace(/[^0-9]/g, '');
  }
  // /// PUBLIC /////////////////////////////////////////////////////////////////
  /**
  * Metoda walidująca przekazany numer - sprawdza czy string składa się z samych cyfr
  * i określonej ilości znaków (domyślnie jest to 9 znaków).
  *
  * @method validateNumber(number, length)
  * @param {Integer} number - numer wpisany przez użytkownika
  * @param {Integer} length - maksymalna ilość znaków w numerze
  * @access public
  */
  function validateNumber(number, length) {
    return this.__checkNumberLength(this.__checkNumberCharacters(number), length);
  }
}();

/* harmony default export */ __webpack_exports__["a"] = (sNumberValidation);

/***/ }),

/***/ 1034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7241932e_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1042);
function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var normalizeComponent = __webpack_require__(18)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7241932e_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(1053);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eed178f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1246);
function injectStyle (ssrContext) {
  __webpack_require__(1244)
}
var normalizeComponent = __webpack_require__(18)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eed178f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1040:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1041);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("059202a8", content, true, {});

/***/ }),

/***/ 1041:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, ".small-loading-spinner{z-index:10;position:absolute;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;border-radius:4px;width:100%;height:100%}.small-loading-spinner--form{height:95%;width:96%}.spinner{width:50px;height:50px;text-align:center;animation:sk-rotate 2s infinite linear}.spinner__dot-1,.spinner__dot-2{width:60%;height:60%;display:inline-block;position:absolute;top:0;background-color:#acf158;border-radius:100%;animation:sk-bounce 2s infinite ease-in-out}.spinner__dot-2{top:auto;bottom:0;animation-delay:-1s}@keyframes sk-rotate{to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}@keyframes sk-bounce{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Common/SmallLoadingSpinner/style.sass"],"names":[],"mappings":"AACA,uBACE,WAAY,AACZ,kBAAmB,AACnB,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,sBAAuB,AACnB,mBAAoB,AACxB,kBAAmB,AACnB,WAAY,AACZ,WAAa,CACd,AACD,6BACE,WAAY,AACZ,SAAW,CACZ,AACD,SACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,sCAA0C,CAC3C,AACD,gCACE,UAAW,AACX,WAAY,AACZ,qBAAsB,AACtB,kBAAmB,AACnB,MAAO,AACP,yBAA0B,AAC1B,mBAAoB,AACpB,2CAA+C,CAChD,AACD,gBACE,SAAU,AACV,SAAU,AACV,mBAAuB,CACxB,AACD,qBACA,GACI,wBAA0B,AAC1B,+BAAkC,CACrC,CACA,AACD,qBACA,MACI,mBAAoB,AACpB,0BAA4B,CAC/B,AACD,IACI,mBAAoB,AACpB,0BAA4B,CAC/B,CACA","file":"style.sass","sourcesContent":["\n.small-loading-spinner {\n  z-index: 10;\n  position: absolute;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n}\n.small-loading-spinner--form {\n  height: 95%;\n  width: 96%;\n}\n.spinner {\n  width: 50px;\n  height: 50px;\n  text-align: center;\n  animation: sk-rotate 2.0s infinite linear;\n}\n.spinner__dot-1, .spinner__dot-2 {\n  width: 60%;\n  height: 60%;\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  background-color: #ACF158;\n  border-radius: 100%;\n  animation: sk-bounce 2.0s infinite ease-in-out;\n}\n.spinner__dot-2 {\n  top: auto;\n  bottom: 0;\n  animation-delay: -1.0s;\n}\n@keyframes sk-rotate {\n100% {\n    transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n}\n}\n@keyframes sk-bounce {\n0%, 100% {\n    transform: scale(0);\n    -webkit-transform: scale(0);\n}\n50% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return (typeof _vm.props.isVisible !== 'undefined' ? _vm.props.isVisible : true)?_c('div',{staticClass:"small-loading-spinner"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner__dot-1"}),_vm._v(" "),_c('div',{staticClass:"spinner__dot-2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AppVersion',

  data: function data() {
    return {
      version: "2.5.12"
    };
  }
});

/***/ }),

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_sNumberValidation__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Common_SmallLoadingSpinner__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_LoginErrorMessages__ = __webpack_require__(1039);

/**
* description:
* File of container LoginSubscriberNumberForm Component (Dumb)
*
* data : 2017-08-03
*/




// CHILD COMPONENTS ////////////////////////////////////////////////////////////



// COMPONENT ///////////////////////////////////////////////////////////////////
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginSubscriberNumberForm',

  components: {
    LoginErrorMessages: __WEBPACK_IMPORTED_MODULE_4__components_Login_LoginErrorMessages__["a" /* default */], SmallLoadingSpinner: __WEBPACK_IMPORTED_MODULE_3__components_Common_SmallLoadingSpinner__["a" /* default */]
  },

  props: ['loginCredentialsIncorrect', 'loginLoadingActive'],

  data: function data() {
    return {
      subscriberNumber: null
    };
  },
  beforeMount: function beforeMount() {
    this.resetNumber();
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['checkNumber']), {
    submitSubscriberNumber: function submitSubscriberNumber() {
      var subscriberNumber = this.subscriberNumber;
      this.checkNumber({ subscriberNumber: subscriberNumber });
    },
    validatePhoneNumber: function validatePhoneNumber() {
      var number = __WEBPACK_IMPORTED_MODULE_2__services_sNumberValidation__["a" /* default */].validateNumber(this.subscriberNumber);
      this.subscriberNumber = number;
    },
    resetNumber: function resetNumber() {
      this.subscriberNumber = null;
    }
  })
});

/***/ }),

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 13:01:08
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



// COMPONENT ///////////////////////////////////////////////////////////////////
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginErrorMessages',

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['loginErrorReason']))
});

/***/ }),

/***/ 1054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginRpcErrorMessage',

  props: [],

  data: function data() {
    return {};
  },


  computed: {},

  methods: {}
});

/***/ }),

/***/ 1229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(1051);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598c5b1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1232);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(18)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-598c5b1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_598c5b1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("f0e699c6", content, true, {});

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, ".AppVersion[data-v-598c5b1c]{position:absolute;right:10px;top:5px;font-size:12px}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Common/AppVersion/style.sass"],"names":[],"mappings":"AACA,6BACE,kBAAmB,AACnB,WAAY,AACZ,QAAS,AACT,cAAgB,CACjB","file":"style.sass","sourcesContent":["\n.AppVersion[data-v-598c5b1c] {\n  position: absolute;\n  right: 10px;\n  top: 5px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppVersion"},[_vm._v("\n  version: "+_vm._s(_vm.version)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b14814_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1236);
function injectStyle (ssrContext) {
  __webpack_require__(1234)
}
var normalizeComponent = __webpack_require__(18)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79b14814_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1235);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("25573b0e", content, true, {});

/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, ".login-background{position:absolute;z-index:-1}.login-background__image{position:fixed;animation:kenburns-top 5s ease-out both;background-color:#efefef}@keyframes kenburns-top{0%{-webkit-transform:scale(1) translateY(0);-webkit-transform-transform:scale(1) translateY(0);-webkit-transform-origin:50% 16%;-webkit-transform-origin-transform-origin:50% 16%}to{-webkit-transform:scale(1.25) translateY(-15px);-webkit-transform-transform:scale(1.25) translateY(-15px);-webkit-transform-origin:top;-webkit-transform-origin-transform-origin:top}}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Login/LoginBackground/style.sass"],"names":[],"mappings":"AACA,kBACE,kBAAmB,AACnB,UAAY,CACb,AACD,yBACE,eAAgB,AAChB,wCAAyC,AACzC,wBAA0B,CAC3B,AACD,wBACA,GACI,yCAA0C,AACxC,mDAAoD,AACtD,iCAAkC,AAChC,iDAAmD,CACxD,AACD,GACI,gDAAiD,AAC/C,0DAA2D,AAC7D,6BAA8B,AAC5B,6CAA+C,CACpD,CACA","file":"style.sass","sourcesContent":["\n.login-background {\n  position: absolute;\n  z-index: -1;\n}\n.login-background__image {\n  position: fixed;\n  animation: kenburns-top 5s ease-out both;\n  background-color: #efefef;\n}\n@keyframes kenburns-top {\n0% {\n    -webkit-transform: scale(1) translateY(0);\n      -webkit-transform-transform: scale(1) translateY(0);\n    -webkit-transform-origin: 50% 16%;\n      -webkit-transform-origin-transform-origin: 50% 16%;\n}\n100% {\n    -webkit-transform: scale(1.25) translateY(-15px);\n      -webkit-transform-transform: scale(1.25) translateY(-15px);\n    -webkit-transform-origin: top;\n      -webkit-transform-origin-transform-origin: top;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"login-background"},[_c('img',{staticClass:"login-background__image",attrs:{"src":__webpack_require__(1017)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8ec188_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1240);
function injectStyle (ssrContext) {
  __webpack_require__(1238)
}
var normalizeComponent = __webpack_require__(18)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8ec188_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1239);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("a1d96072", content, true, {});

/***/ }),

/***/ 1239:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, ".login-logo{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;position:relative;top:80px}@media screen and (max-width:768px){.login-logo{top:30px}}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Login/LoginLogo/style.sass"],"names":[],"mappings":"AACA,YACE,oBAAqB,AACrB,aAAc,AACd,qBAAsB,AAClB,uBAAwB,AAC5B,kBAAmB,AACnB,QAAU,CACX,AACD,oCACA,YACM,QAAU,CACf,CACA","file":"style.sass","sourcesContent":["\n.login-logo {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  position: relative;\n  top: 80px;\n}\n@media screen and (max-width: 768px) {\n.login-logo {\n      top: 30px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"login-logo"},[_c('img',{attrs:{"src":_vm.props.brandLogos.main}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(1052);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308c3ba6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1247);
function injectStyle (ssrContext) {
  __webpack_require__(1242)
}
var normalizeComponent = __webpack_require__(18)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308c3ba6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1242:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1243);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("0347269b", content, true, {});

/***/ }),

/***/ 1243:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"style.sass","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1245);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("7ddabd44", content, true, {});

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, ".login-error-message{padding:5px;border:1px solid #ec5567;border-radius:5px;font-size:12px;font-family:proxima_softsemibold,sans-serif;color:#ec5567;background-color:#ffd7e9;margin-bottom:10px}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Login/LoginErrorMessages/style.sass"],"names":[],"mappings":"AACA,qBACE,YAAa,AACb,yBAA0B,AAC1B,kBAAmB,AACnB,eAAgB,AAChB,4CAAgD,AAChD,cAAe,AACf,yBAA0B,AAC1B,kBAAoB,CACrB","file":"style.sass","sourcesContent":["\n.login-error-message {\n  padding: 5px;\n  border: 1px solid #EC5567;\n  border-radius: 5px;\n  font-size: 12px;\n  font-family: 'proxima_softsemibold', sans-serif;\n  color: #EC5567;\n  background-color: #ffd7e9;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-error-message animated fadeIn"},[_vm._v("\n  "+_vm._s(_vm.loginErrorReason)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper animated fadeIn"},[_c('form',{staticClass:"login-form",on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"login__content",class:{ 'login__content--loading' : _vm.loginLoadingActive }},[_c('h2',{staticClass:"login-form__heading"},[_vm._v("Witaj w Panelu Online!")]),_vm._v(" "),_c('p',{staticClass:"login-form__lead"},[_vm._v("Aby się zalogować, wpisz swój numer telefonu komórkowego")]),_vm._v(" "),(_vm.loginCredentialsIncorrect)?_c('LoginErrorMessages'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("+48")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subscriberNumber),expression:"subscriberNumber"}],staticClass:"login-form__input form-control input-lg",attrs:{"type":"text","name":"subscriberNumber","placeholder":"Numer telefonu","autofocus":""},domProps:{"value":(_vm.subscriberNumber)},on:{"keyup":_vm.validatePhoneNumber,"input":function($event){if($event.target.composing){ return; }_vm.subscriberNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(!_vm.loginLoadingActive)?_c('button',{staticClass:"btn button btn-lg btn-block",attrs:{"disabled":!_vm.subscriberNumber || _vm.subscriberNumber.length < 9},on:{"click":_vm.submitSubscriberNumber}},[_vm._v("\n          Dalej\n        ")]):_vm._e(),_vm._v(" "),(_vm.loginLoadingActive)?_c('button',{staticClass:"btn button btn-lg btn-block",attrs:{"disabled":true}},[_vm._v("\n          Sprawdzam numer\n        ")]):_vm._e()])],1)]),_vm._v(" "),_c('SmallLoadingSpinner',{attrs:{"is-visible":_vm.loginLoadingActive}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(1054);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e17722c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1251);
function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(18)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e17722c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e17722c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1249:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1250);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1015)("40c7758e", content, true, {});

/***/ }),

/***/ 1250:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1014)(true);
// imports


// module
exports.push([module.i, ".LoginRpcErrorMessage[data-v-6e17722c]{margin-top:80px}", "", {"version":3,"sources":["/builds/new-media/lajt-online.pl/platform/src/components/Login/LoginRpcErrorMessage/style.sass"],"names":[],"mappings":"AACA,uCACE,eAAiB,CAClB","file":"style.sass","sourcesContent":["\n.LoginRpcErrorMessage[data-v-6e17722c] {\n  margin-top: 80px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LoginRpcErrorMessage"},[_c('div',{staticClass:"login-wrapper animated fadeIn"},[_c('div',{staticClass:"login-form"},[_c('h2',{staticClass:"login-form__heading"},[_vm._v("Witaj w Panelu Online!")]),_vm._v(" "),_c('h4',[_c('span',{staticClass:"break-line"},[_vm._v("Trwa aktualizacja bazy danych.")]),_vm._v(" "),_c('span',{staticClass:"break-line"},[_vm._v("Logowanie nie jest aktualnie możliwe.")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"break-line"},[_vm._v("W przypadku pytań prosimy o kontakt z naszym BOK")]),_vm._v(" "),_c('span',{staticClass:"break-line"},[_vm._v("e-mail: info@lajtmobile.pl")]),_vm._v(" "),_c('span',{staticClass:"break-line"},[_vm._v("tel.: 727700700 (opł. jak za poł. na nr komórkowy)")]),_vm._v(" "),_c('span',{staticClass:"break-line",staticStyle:{"margin-top":"10px"}},[_c('b',[_vm._v("Za utrudnienia przepraszamy.")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.72b0493ac4bb9c22b619.js